module.exports = __webpack_public_path__ + "img/README.6243e067.png";